import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// تعریف نوع برای رنگ‌ها
export interface ColorToast {
  success: string;
  info: string;
  warning: string;
  error: string;
  wait: string; // اضافه شدن نوع برای "صبر کنید"
}

// تعریف تابع گلوبال برای نمایش Toast
export const showToast = (
  message: string, // پیام
  color: keyof ColorToast = "info", // رنگ پیش‌فرض
  wait = false // فلگ برای نمایش "صبر کنید"
) => {
  const toastOptions: ToastOptions = {
    position: "bottom-left", // موقعیت نمایش Toast
    autoClose: wait ? false : 5000, // در حالت "صبر کنید" غیر فعال کردن autoClose
    hideProgressBar: false, // نمایش Progress Bar
    closeOnClick: !wait, // بستن Toast با کلیک (برای حالت "صبر کنید" غیرفعال)
    pauseOnHover: true, // توقف با Hover
    draggable: true, // قابلیت Drag کردن
    theme: "colored", // تم رنگی
  };

  if (wait) {
    toast.loading(message, toastOptions);
  } else {
    switch (color) {
      case "success":
        toast.success(message, toastOptions);
        break;
      case "info":
        toast.info(message, toastOptions);
        break;
      case "warning":
        toast.warning(message, toastOptions);
        break;
      case "error":
        toast.error(message, toastOptions);
        break;
      default:
        toast.info(message, toastOptions);
        break;
    }
  }
};
